import React from 'react';
import { formatBlocks, learnOutputs } from '../../data/proposal';
export function FormatPanel() {
  return <div data-id="element-77" data-mp="gaelwilu8829">
      <h2 className="text-[36px] font-medium leading-[1.04] tracking-[-0.035em] text-navy md:text-[48px]" data-id="element-78" data-mp="gaodgamj6na2">
        What the Snakker format adds
      </h2>
      <div className="mt-8 grid gap-6 sm:grid-cols-2 lg:grid-cols-5 lg:gap-0" data-id="element-79" data-mp="6b5sbquvwvgf">
        {formatBlocks.map((b, i) => <article key={b.title} className={`lg:px-5 ${i === 0 ? 'lg:pl-0' : 'lg:border-l lg:border-navy/10'}`} data-id="element-80" data-mp="1ccg01rc3ahu" data-mpi={i}>
            <h3 className="text-xl font-medium tracking-[-0.02em] text-navy" data-id="element-81" data-mp="3spp7vqvligoh">{b.title}</h3>
            <p className="mt-2 text-sm leading-relaxed text-navy/60" data-id="element-82" data-mp="3oodinmgmvxgt">{b.body}</p>
          </article>)}
      </div>

      <div className="mt-12 border-t border-navy/10 pt-10" data-id="element-83" data-mp="3jrn10up6ktta">
        <h3 className="text-2xl font-medium tracking-[-0.02em] text-navy" data-id="element-84" data-mp="3erijd1cjdt1h">Engagement creates insight</h3>
        <p className="mt-3 max-w-2xl text-base leading-relaxed text-navy/65" data-id="element-85" data-mp="39re39cfjj0bs">
          The primary job is a short, useful HCP interaction. Because the HCP actively participates, it also generates useful
          signals. In this illustrative example we could learn:
        </p>
        <ul className="mt-5 flex flex-wrap gap-2" data-id="element-86" data-mp="sx3rmcn8esn7">
          {learnOutputs.map(o => <li key={o} className="rounded-full border border-navy/15 px-4 py-2 text-sm text-navy/80" data-id="element-87" data-mp="xw6o38p5bqjk">
              {o}
            </li>)}
        </ul>
        <p className="mt-6 text-lg font-medium text-navy" data-id="element-88" data-mp="1lmaq5bmori8g">Every interaction creates a signal.</p>
      </div>
    </div>;
}